import messaging from '../firebase_messaging';

export const setDeviceToken = async () => {
    var device_token = localStorage.getItem('device_token');
    if (device_token === null){
      messaging.requestPermission().then(() => {
        return messaging.getToken();
      }).then(token=>{
        localStorage.setItem('device_token', token);
      }).catch(error=> {
        console.error(error);
      }).catch(error=> {
        console.error(error);
      });
    }
}